import { render } from "./Pegboard.vue?vue&type=template&id=3b4eb03b&scoped=true"
import script from "./Pegboard.vue?vue&type=script&lang=js"
export * from "./Pegboard.vue?vue&type=script&lang=js"

import "./Pegboard.vue?vue&type=style&index=0&id=3b4eb03b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4eb03b"]])

export default __exports__